import React, { useEffect, useState } from 'react';
import { Tabs, Tab } from '@material-ui/core';

import UserList from './UserList';
import GroupList from './GroupList';

const Users = props => {
  const [selectedTab, setSelectedTab] = useState(getSelectedTab(props.location.state));

  useEffect(() => {
    setSelectedTab(getSelectedTab(props.location.state));
  }, [props.location.state]);

  return (
    <div style={{ minWidth: 992, maxWidth: 1100 }}>
      <Tabs
        value={selectedTab}
        onChange={(_e, tab) =>
          props.history.push('/dashboard/users', { selectedTab: tab })
        }
      >
        <Tab label="Users" />
        <Tab label="groups" />
      </Tabs>

      {selectedTab === 0 && <UserList />}
      {selectedTab === 1 && <GroupList />}
    </div>
  );
};

export default Users;

const getSelectedTab = state => {
  if (state) {
    const selected = state.selectedTab;

    if (!isNaN(selected) && selected in [0, 1]) {
      return selected;
    }
  }

  return 0;
};
